var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.hideHeader)?_c('AppHeader',{attrs:{"isScrolled":_vm.isScrolled,"hiddenLogo":!_vm.$route.meta.hiddenLogo}}):_vm._e(),_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('router-view',{key:_vm.routerKey})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }